import React, { useEffect, useState } from 'react';
import Button from './core/Button';
import Modal from './Modals/Modal';
import styles from './SaveFilterDialog.module.scss';

export interface Props {
  filter?: string;
  open: boolean;
  onClose: () => void;
}

export default function SaveFilterDialog(props: Props) {
  const [filterName, setFilterName] = useState('');
  const [options, setOptions] = useState<any>([]);
  const saveFilterApi = () => {};

  useEffect(() => {
    setOptions([
      {
        title: 'Notificaciones Instantanea',
        description: 'Te enviaremos notificaiones a tu correo de tiempo real.',
        plan: '(Inversor+)',
      },
      {
        title: 'Notificaciones Diarias',
        description: 'Te enviaremos notificaiones a tu correo cada dia.',
        plan: '',
      },
      {
        title: 'Sin notificaciones',
        description: 'No se te enviaran notificaciones al correo.',
        plan: '',
      },
    ]);
  }, []);

  return (
    <Modal
      title="Notificaciones"
      open={props.open}
      onClose={props.onClose}
      footer={
        <div className={styles.footerBtns}>
          <Button label="CERRAR" onClick={props.onClose} />
          <Button label="GUARDAR" onClick={saveFilterApi} />
        </div>
      }
    >
      <>
        <section>
          <h2>Nombre del filtro</h2>
          <input
            className={styles.inputMui}
            value={filterName}
            onInput={(value: any) => {
              setFilterName(value.target.value);
            }}
            placeholder="Nombre del filtro"
          />
        </section>
        <section>
          <h2>Notificaciones por email</h2>
          <div className={styles.checkboxList}>
            {options.map((item: any) => (
              <label key={item.title}>
                <div className={styles.containerCheckBoxes}>
                  <div>
                    <div className={styles.title}>
                      <span>{item.title}</span>
                      <span className={styles.plan}>{item.plan}</span>
                    </div>
                    <div className={styles.description}>
                      <span>{item.description}</span>
                    </div>
                  </div>
                  <input
                    className={styles.checkboxItem}
                    type="checkbox"
                    name="features"
                    value={item.title}
                  />
                </div>
              </label>
            ))}
          </div>
        </section>
      </>
    </Modal>
  );
}
